import i18n from "i18n";

const tableHeaders  = {
    code: {

        name: 'code',
        title: i18n.t("code").toUpperCase(),
        active: false,
        direction: false,
        value: "code",


    },
    date: {
        name: 'date',
        title: i18n.t("creation.date").toUpperCase(),
        active: false,
        direction: false,
        value: "created_at"
    },
    owner: {
        name: 'owner',
      title: i18n.t("owner").toUpperCase(),
      active: false,
      direction: false,
      value: "owner",
    },
    state: {
        name: 'state',
        title: i18n.t("state").toUpperCase(),
        active: false,
        direction: false,
        value: "status"
    }
}



  export default tableHeaders;